module.exports = __webpack_public_path__ + "static/media/kolefnis-island.a3503a9a.mp4";